module.exports = __webpack_public_path__ + "static/tpp-icon-globe-39456e3461cad02534ce42b26a0f464f.png";